import React from 'react'
import { useContext } from '../Context'
import { Icon, Link, ShowIf } from '@ztechapps/webui.util'
import type { QueryFilter } from '../../../../config/types'

export const ClearFilter = ({ filterName }: { filterName: string }) => {
  const { resetFilter, onChangeFilter } = useContext()
  const reset = (e) => {
    e.preventDefault()
    const resetValue = resetFilter?.[filterName]?.value as Partial<QueryFilter>

    onChangeFilter(resetValue)
  }

  const hasValue = resetFilter?.[filterName]?.hasValue

  return (
    <ShowIf condition={hasValue}>
      <Link className="text-danger" onClick={reset} data-joyridestep="filter_shape_clear">
        <Icon name="minus-circle" /> Clear
      </Link>
    </ShowIf>
  )
}
